// components/schema/SchemaHeader.jsx

import React from "react"

export default function SchemaHeader() {
  return (
    <div className="flex items-center justify-between mb-3 bg-white/70 dark:bg-gray-900/70 backdrop-blur supports-[backdrop-filter]:bg-white/50 dark:supports-[backdrop-filter]:bg-gray-900/50 z-10 py-2">
      <div>
        <h1 className="text-xl font-semibold">Schema</h1>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Grammar-aware editor with syntax validation and graph preview
        </p>
      </div>
    </div>
  )
}
